/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateSigfoxDeviceRequest model module.
* @module model/CreateSigfoxDeviceRequest
* @version 2020-12-7
*/
export default class CreateSigfoxDeviceRequest {
    /**
    * Constructs a new <code>CreateSigfoxDeviceRequest</code>.
    * Sigfoxのデバイス登録リクエスト
    * @alias module:model/CreateSigfoxDeviceRequest
    * @class
    * @param lineId {Number} ラインID
    * @param deviceId {String} デバイスID
    * @param pac {String} テストデータ
    */

    constructor(lineId, deviceId, pac) {
        
        
        this['lineId'] = lineId;
        this['deviceId'] = deviceId;
        this['pac'] = pac;
        
    }

    /**
    * Constructs a <code>CreateSigfoxDeviceRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateSigfoxDeviceRequest} obj Optional instance to populate.
    * @return {module:model/CreateSigfoxDeviceRequest} The populated <code>CreateSigfoxDeviceRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateSigfoxDeviceRequest();
                        
            
            if (data.hasOwnProperty('lineId')) {
                obj['lineId'] = ApiClient.convertToType(data['lineId'], 'Number');
            }
            if (data.hasOwnProperty('deviceId')) {
                obj['deviceId'] = ApiClient.convertToType(data['deviceId'], 'String');
            }
            if (data.hasOwnProperty('pac')) {
                obj['pac'] = ApiClient.convertToType(data['pac'], 'String');
            }
        }
        return obj;
    }

    /**
    * ラインID
    * @member {Number} lineId
    */
    'lineId' = undefined;
    /**
    * デバイスID
    * @member {String} deviceId
    */
    'deviceId' = undefined;
    /**
    * テストデータ
    * @member {String} pac
    */
    'pac' = undefined;




}
